import SocketIO from 'socket.io-client'
import Config from 'src/config'

export default SocketIO(Config.SOCKET_URL)
